import { render, staticRenderFns } from "./networkNtp.vue?vue&type=template&id=1f48feb6&scoped=true"
import script from "./networkNtp.vue?vue&type=script&lang=js"
export * from "./networkNtp.vue?vue&type=script&lang=js"
import style0 from "./networkNtp.vue?vue&type=style&index=0&id=1f48feb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f48feb6",
  null
  
)

export default component.exports